import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-icon',
  templateUrl: './button-icon.component.html',
})
export class ButtonIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
